module.exports = __webpack_public_path__ + "static/img/logo.b86d116d.png";